import { AdminRoutes } from "components/Admin/AdminNavigation/AdminRoutes";
import { Routes } from "components/Navigation/Routes";
import { Observer } from "mobx-react-lite";
import Organization from "models/Organization";
import React, { CSSProperties } from "react";
import { useLocation } from "react-router-dom";
import { AuthStore } from "../../../stores/AuthStore";
import { useStore } from "../../../utils/useStore";
import AcxSelectSingle from "./BaseSelectComponents/AcxSelectSingle";

interface IOrgSelectV2 {
    id: string;
    onLoading?: (isLoading: boolean) => void;
    showLoading?: boolean;
    onError?: (errorMessage?: string) => void;
    onSelect?: (org: Organization) => void;
    onDisplay?: (isVisible: boolean) => void;
    label?: string;
    fullWidth?: boolean;
    menuPortalTarget?: HTMLElement | null | undefined;
    disabled?: boolean;
    autoSelectUsersOrg?: boolean;
    defaultValue?: any;
    customStyle?: any;
    orgId?: string;
    customRootStyles?: CSSProperties;
    disableGlobalOrgChange?: boolean;
}

function OrgSelectV2(props: IOrgSelectV2) {
    const authStore = useStore(AuthStore);
    const location = useLocation();
    const previousPath = location.state.previousPath;

    const handleChange = async (val) => {
        if (!val) {
            return;
        }

        // val may be a lightweight tenant option (id + name) while impersonating;
        // setGlobalOrganization accepts an { id } selection and re-fetches the full org.
        if (previousPath.includes("admin")) {
            const selectedOrgId = val.id;
            const orgDetailsRoute = `${AdminRoutes.routePrefix}${AdminRoutes.ORGANIZATIONS}/${selectedOrgId}`;
            const didSelectOrganization =
                await authStore.orgStore.setGlobalOrganization(
                    val,
                    orgDetailsRoute,
                );
            if (!didSelectOrganization) {
                return;
            }

            window.location.replace(orgDetailsRoute);

            return;
        }

        const didSelectOrganization =
            await authStore.orgStore.setGlobalOrganization(val, Routes.HOME);
        if (!didSelectOrganization) {
            return;
        }

        window.location.replace(Routes.HOME);
    };

    return (
        <Observer>
            {() => (
                <div
                    style={{
                        ...{
                            display:
                                (authStore.accessibleTenantOptions?.length ||
                                    0) > 1
                                    ? "block"
                                    : "none",
                        },
                        ...props.customRootStyles,
                    }}
                >
                    <AcxSelectSingle
                        inputLabel={props.label}
                        fullWidth={props.fullWidth}
                        isDisabled={props.disabled}
                        defaultValue={
                            props.defaultValue ||
                            authStore.orgStore?.selectedOrganization
                        }
                        id={`org-selector-${props.id}`}
                        labelField="name"
                        valueField="id"
                        options={authStore.accessibleTenantOptions}
                        onChange={handleChange}
                        placeholder={
                            props.showLoading &&
                            authStore.orgStore.anyTaskLoading
                                ? "Loading.."
                                : "Select Organization"
                        }
                        menuPortalTarget={props.menuPortalTarget}
                        customStyle={props.customStyle}
                    />
                </div>
            )}
        </Observer>
    );
}

export default OrgSelectV2;
